module.exports = {"maxSwipeTime":300,"minHorizontalSwipeDistance":60,"maxVerticalSwipeDistance":80}


//////////////////
// WEBPACK FOOTER
// ./src/lib/v-calendar/utils/defaults/touch.json
// module id = SS1k
// module chunks = 1